import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAppToast } from "../../Components/Toast/showAppToast";
import Loading from "../../Components/Loading/Loading";
import styles from "./PDFViewer.module.css";
import { MdShare } from "react-icons/md";
import {fetchFileContent} from "../../Services/Slices/fileContentSlice";

const PDFViewer = () => {
    const { fileKey } = useParams<{ fileKey: string }>();
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(
        (state: any) => state.fileContentSlice
    );
    const [redirect, setRedirect] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch<any>(fetchFileContent(fileKey));
    }, [dispatch, fileKey]);

    useEffect(() => {
        if (!error) return;
        showAppToast("error");
        const timer = setTimeout(() => {
            setRedirect(true);
        }, 4000);
        return () => clearTimeout(timer);
    }, [error]);

    useEffect(() => {
        if (redirect) {
            navigate("/");
        }
    }, [redirect, navigate]);

    const handleShare = () => {
        const url = window.location.href;
        navigator.clipboard
            .writeText(url)
            .then(() => showAppToast("copySuccess"))
            .catch((copyError) => {
                console.error("Erro ao copiar a URL: ", copyError);
                showAppToast("copyError");
            });
    };

    return (
        <div className={styles.pdfContainer}>
            {loading && <Loading size="5rem" type="spin" label="Carregando PDF..." />}
            {data && (
                <div className={styles.pdfWrapper}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={`data:application/pdf;base64,${data}`}
                            defaultScale={2}
                        />
                    </Worker>
                    <button className={styles.button} onClick={handleShare}>
                        <MdShare size={24} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default PDFViewer;